import React, { useCallback } from "react";
import ICheckbox from "./ICheckbox";
import SubGroup from "../../../common/SubGroup";

function StraightTab({ profile }) {
  const handleChanged = useCallback(
    (value, key) => {
      profile[key] = value;
      profile[`Change${key}`] = true;

      console.log(profile);
    },
    [profile]
  );

  const handlePlayerProfileStraightLimitFootballChanged = useCallback(
    (value, key) => {
      profile["PlayerProfileStraightLimitFootball"] = {
        ...profile["PlayerProfileStraightLimitFootball"],
        [key]: value,
        [`Change${key}`]: true,
      };

      console.log(profile);
    },
    [profile]
  );

  const handlePlayerProfileStraightLimitBasketballChanged = useCallback(
    (value, key) => {
      profile["PlayerProfileStraightLimitBasketball"] = {
        ...profile["PlayerProfileStraightLimitBasketball"],
        [key]: value,
        [`Change${key}`]: true,
      };

      console.log(profile);
    },
    [profile]
  );

  return (
    <div className="grid h-full grid-cols-2 gap-2">
      <div className="flex flex-col h-full min-h-0 col-span-1 gap-2">
        <SubGroup title="Football" className="grid grid-cols-2 gap-2 p-2">
          <div className="flex flex-col">
            <ICheckbox
              label="NFL"
              onChanged={(value) => {
                if (value) {
                  profile["PlayerProfileStraightLimitFootball"].IdSports.add(
                    "NFL"
                  );
                } else {
                  profile["PlayerProfileStraightLimitFootball"].IdSports.delete(
                    "NFL"
                  );
                }
                console.log(profile);
              }}
            />
            <ICheckbox
              label="CFB"
              onChanged={(value) => {
                if (value) {
                  profile["PlayerProfileStraightLimitFootball"].IdSports.add(
                    "CFB"
                  );
                } else {
                  profile["PlayerProfileStraightLimitFootball"].IdSports.delete(
                    "CFB"
                  );
                }
                console.log(profile);
              }}
            />
          </div>
          <div className="flex flex-col">
            <ICheckbox
              label="Sprd Points Purchase Max"
              onChanged={(value) =>
                handlePlayerProfileStraightLimitFootballChanged(
                  value,
                  "SpreadPointsPurchaseMax"
                )
              }
            />
            <ICheckbox
              label="Sprd Price Half Points"
              onChanged={(value) =>
                handlePlayerProfileStraightLimitFootballChanged(
                  value,
                  "SpreadPriceHalfPoints"
                )
              }
            />
            <ICheckbox
              label="Sprd Extra Juice"
              onChanged={(value) =>
                handlePlayerProfileStraightLimitFootballChanged(
                  value,
                  "SpreadJuiceDefault"
                )
              }
            />
            <ICheckbox
              label="Total Points Purchase Max"
              onChanged={(value) =>
                handlePlayerProfileStraightLimitFootballChanged(
                  value,
                  "TotalPointsPurchaseMax"
                )
              }
            />
            <ICheckbox
              label="Total Price Half Points"
              onChanged={(value) =>
                handlePlayerProfileStraightLimitFootballChanged(
                  value,
                  "TotalPriceHalfPoints"
                )
              }
            />
            <ICheckbox
              label="Total Extra Juice"
              onChanged={(value) =>
                handlePlayerProfileStraightLimitFootballChanged(
                  value,
                  "TotalJuiceDefault"
                )
              }
            />
            <ICheckbox
              label="On 3 Surcharge"
              onChanged={(value) =>
                handlePlayerProfileStraightLimitFootballChanged(
                  value,
                  "On3Surcharge"
                )
              }
            />
            <ICheckbox
              label="Off 3 Surcharge"
              onChanged={(value) =>
                handlePlayerProfileStraightLimitFootballChanged(
                  value,
                  "Off3Surcharge"
                )
              }
            />
            <ICheckbox
              label="On 7 Surcharge"
              onChanged={(value) =>
                handlePlayerProfileStraightLimitFootballChanged(
                  value,
                  "On7Surcharge"
                )
              }
            />
            <ICheckbox
              label="Off 7 Surcharge"
              onChanged={(value) =>
                handlePlayerProfileStraightLimitFootballChanged(
                  value,
                  "Off7Surcharge"
                )
              }
            />
            <ICheckbox
              label="Skip Half Point"
              onChanged={(value) =>
                handlePlayerProfileStraightLimitFootballChanged(
                  value,
                  "SkipHalfPoint"
                )
              }
            />
            <ICheckbox
              label="Add Surcharge Twice 3pts"
              onChanged={(value) =>
                handlePlayerProfileStraightLimitFootballChanged(
                  value,
                  "SurchargeTwice_3pts"
                )
              }
            />
            <ICheckbox
              label="Add Surcharge Twice 7pts"
              onChanged={(value) =>
                handlePlayerProfileStraightLimitFootballChanged(
                  value,
                  "SurchargeTwice_7pts"
                )
              }
            />
            <ICheckbox
              label="Can Buy Points On 3"
              onChanged={(value) =>
                handlePlayerProfileStraightLimitFootballChanged(
                  value,
                  "CanBuyOn3"
                )
              }
            />
            <ICheckbox
              label="Can Buy Points Off 3"
              onChanged={(value) =>
                handlePlayerProfileStraightLimitFootballChanged(
                  value,
                  "CanBuyOff3"
                )
              }
            />
            <ICheckbox
              label="Can Buy Points On 7"
              onChanged={(value) =>
                handlePlayerProfileStraightLimitFootballChanged(
                  value,
                  "CanBuyOn7"
                )
              }
            />
            <ICheckbox
              label="Can Buy Points Off 7"
              onChanged={(value) =>
                handlePlayerProfileStraightLimitFootballChanged(
                  value,
                  "CanBuyOff7"
                )
              }
            />
          </div>
        </SubGroup>
      </div>
      <div className="flex flex-col h-full col-span-1 gap-2">
        <SubGroup
          title="Basketball"
          className="grid h-full grid-cols-2 gap-2 p-2"
        >
          <div className="flex flex-col">
            <ICheckbox
              label="NBA"
              onChanged={(value) => {
                if (value) {
                  profile["PlayerProfileStraightLimitBasketball"].IdSports.add(
                    "NBA"
                  );
                } else {
                  profile[
                    "PlayerProfileStraightLimitBasketball"
                  ].IdSports.delete("NBA");
                }
                console.log(profile);
              }}
            />
            <ICheckbox
              label="CBB"
              onChanged={(value) => {
                if (value) {
                  profile["PlayerProfileStraightLimitBasketball"].IdSports.add(
                    "CBB"
                  );
                } else {
                  profile[
                    "PlayerProfileStraightLimitBasketball"
                  ].IdSports.delete("CBB");
                }
                console.log(profile);
              }}
            />
          </div>
          <div className="flex flex-col">
            <ICheckbox
              label="Sprd Points Purchase Max"
              onChanged={(value) =>
                handlePlayerProfileStraightLimitBasketballChanged(
                  value,
                  "SpreadPointsPurchaseMax"
                )
              }
            />
            <ICheckbox
              label="Sprd Price Half Points"
              onChanged={(value) =>
                handlePlayerProfileStraightLimitBasketballChanged(
                  value,
                  "SpreadPriceHalfPoints"
                )
              }
            />
            <ICheckbox
              label="Sprd Extra Juice"
              onChanged={(value) =>
                handlePlayerProfileStraightLimitBasketballChanged(
                  value,
                  "SpreadJuiceDefault"
                )
              }
            />
            <ICheckbox
              label="Total Points Purchase Max"
              onChanged={(value) =>
                handlePlayerProfileStraightLimitBasketballChanged(
                  value,
                  "TotalPointsPurchaseMax"
                )
              }
            />
            <ICheckbox
              label="Total Price Half Points"
              onChanged={(value) =>
                handlePlayerProfileStraightLimitBasketballChanged(
                  value,
                  "TotalPriceHalfPoints"
                )
              }
            />
            <ICheckbox
              label="Total Extra Juice"
              onChanged={(value) =>
                handlePlayerProfileStraightLimitBasketballChanged(
                  value,
                  "TotalJuiceDefault"
                )
              }
            />
            <ICheckbox
              label="Skip Half Point"
              onChanged={(value) =>
                handlePlayerProfileStraightLimitBasketballChanged(
                  value,
                  "SkipHalfPoint"
                )
              }
            />
          </div>
        </SubGroup>
      </div>
      <div className="flex flex-col col-span-1 gap-2 h-min">
        <SubGroup title="If Bets" className="!gap-0 p-2">
          <ICheckbox
            label="Max Number of Parlays"
            onChanged={(value) => handleChanged(value, "IL_MaxParlays")}
          />
          <ICheckbox
            label="Max Level of Parlays"
            onChanged={(value) => handleChanged(value, "IL_MaxLevelParlays")}
          />
          <ICheckbox
            label="Max Number of Teasers"
            onChanged={(value) => handleChanged(value, "IL_MaxTeasers")}
          />
          <ICheckbox
            label="Max Level of Teasers"
            onChanged={(value) => handleChanged(value, "IL_MaxLevelTeasers")}
          />
          <ICheckbox
            label="Max Number of Straight"
            onChanged={(value) => handleChanged(value, "IL_MaxNumberSB")}
          />
          <ICheckbox
            label="Odds Limit"
            onChanged={(value) => handleChanged(value, "ILOddslimit")}
          />
          <ICheckbox
            label="Ask Amount for all Wagers"
            onChanged={(value) => handleChanged(value, "IL_AskAmount")}
          />
          <ICheckbox
            label="Allow Higher Child Risk"
            onChanged={(value) => handleChanged(value, "IL_AllowChildHigher")}
          />
        </SubGroup>
      </div>
      <div className="flex flex-col col-span-1 gap-2 h-min">
        <ICheckbox
          label="Allow Action On MLB Total And RunLine"
          onChanged={(value) =>
            handleChanged(value, "SL_AlwaysActionMLBTotals")
          }
        />
      </div>
    </div>
  );
}

export default StraightTab;
